import React from "react";

export const Contact = () => {
  return (
    <div id="contact" className="w-full min-h-screen bg-cyber-black text-gray-300 py-20 px-6 flex items-center justify-center border-t border-cyber-green/10">
      <div className="max-w-xl w-full space-y-8">
        
        {/* Header */}
        <div className="text-center">
          <h2 className="text-3xl font-mono font-bold text-cyber-green inline border-b-2 border-cyber-green pb-2">
            CONNECT // CONTACT
          </h2>
          <p className="mt-6 text-sm text-cyber-gray-400 font-mono">
            Transmit message via standard SMTP protocol:
          </p>
          <p className="text-cyber-blue font-mono font-bold text-base mt-2 hover:underline cursor-pointer select-all">
            kshatriyaalok1997@gmail.com
          </p>
        </div>

        {/* Form */}
        <form
          action="https://getform.io/f/f7286ea0-c073-449b-8ec5-4c6084b1d606"
          method="POST"
          className="flex flex-col space-y-4 border border-cyber-blue/20 bg-cyber-darker/60 p-8 rounded-2xl shadow-glow-blue-sm"
        >
          <div>
            <label className="block text-xs font-mono text-cyber-gray-400 mb-1">
              SENDER_NAME:
            </label>
            <input
              className="w-full px-4 py-3 bg-cyber-black border border-cyber-gray-800 rounded focus:border-cyber-green text-white font-mono text-sm focus:outline-none transition duration-200"
              type="text"
              placeholder="e.g. Alok Singh"
              name="name"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-mono text-cyber-gray-400 mb-1">
              SENDER_EMAIL:
            </label>
            <input
              className="w-full px-4 py-3 bg-cyber-black border border-cyber-gray-800 rounded focus:border-cyber-green text-white font-mono text-sm focus:outline-none transition duration-200"
              type="email"
              placeholder="e.g. alok@example.com"
              name="email"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-mono text-cyber-gray-400 mb-1">
              TRANSMISSION_PAYLOAD (MESSAGE):
            </label>
            <textarea
              className="w-full px-4 py-3 bg-cyber-black border border-cyber-gray-800 rounded focus:border-cyber-green text-white font-mono text-sm focus:outline-none transition duration-200"
              name="message"
              placeholder="Describe freelance proposals or project specs..."
              rows={5}
              required
            />
          </div>

          <button className="w-full py-3 mt-4 border border-cyber-green text-cyber-green hover:bg-cyber-green hover:text-black font-mono font-bold text-sm tracking-widest rounded shadow-glow-green-sm hover:shadow-glow-green transition duration-300">
            TRANSMIT_MESSAGE()
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
